import { Component, Input, OnInit } from '@angular/core';
import { PanelList } from '../../../shared/models/panel-list';
import { CurriculumService } from '../../services/curriculum.service';
import { TrainingItems } from '../../models/trainingItems';
import { CurriculumConstants } from '../../constants/curriculum.contants';
import { AssignmentGroupInteractionService } from '../../../system-admin/assignment-group/services/assignment-group-interaction.service';
import { Subject, catchError, takeUntil, throwError } from 'rxjs';
import { MenuItem, MessageService } from 'primeng/api';
import { TrainingItemUpdateDto } from '../../models/trainingItemUpdateDto';
import { LinkedTrainingItems } from '../../../shared/models/linkedTrainingItems';
import { TrainingItemDto } from '../../models/trainingItemDto';
import { FilterMenu } from '../../../shared/models/filter-menu';
import { SortMenu } from '../../../shared/models/sort-menu';
import { CommonService } from '../../../shared/services/common.service';
import { SharedConstants } from '../../../shared/constants/shared-constants';
import { NameCode } from '../../../shared/models/name-code';

@Component({
  selector: 'app-curriculum-management-panel-list',
  templateUrl: './curriculum-management-panel-list.component.html',
  styleUrls: ['./curriculum-management-panel-list.component.scss']
})
export class CurriculumManagementPanelListComponent implements OnInit {
  curriculumManagementData: PanelList = {
    lists: [],
    filters: [],
    sort: [],
    enableFilter: true,
    enableSort: true,
    enableSelection: true,
    isCheckBoxContainsDisable:false
  };
  noData: boolean = false;
  showAll : boolean = false;
  selectedTrainingItems: TrainingItems[]=[]
  @Input() selectedScope: any = [];
  unavailableItems: string[] = [];
  documentTrainingItems:any;
  courseTrainingItems:any;
  trainingItems : TrainingItems[] = [];
  documentNumbers : string[] = [];
  courseNumbers : string[] = [];
  isCurriculumDataAvailable: boolean = false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  ifItemsAreSelected: boolean = false;
  statuses: MenuItem[] = [];
  coreOrElective: MenuItem[] = [];
  buttonsShouldBeDisplayed : boolean = false;
  informationIconTooltip : string = CurriculumConstants.ShowAll_InformationIconMessage;
  spinnerOn: boolean = false;
  firstLoad: boolean = false;
  showPanelLoader: boolean = false;
  isScopeSelected = false;
  unAssignTrainingItemGroupBtnLabel : string = CurriculumConstants.Curriculum_UnAssign_Training_Item_Group_Btn_Label;
  isUnAssignTrainingItemGroupSliderOpen : boolean = false;
  curriculumScopeId : string = '';
  selectedTrainingItemGroups: string[] = [];
  trainingItemGroups: NameCode[] = [];
  constructor(private curriculumService : CurriculumService,
    private assignmentGroupInteractionService :AssignmentGroupInteractionService,
    private messageService : MessageService,
    private commonService: CommonService
    ) {
      this.statuses = [
        {
          label: 'Active',
          command : this.active
        },
        {
          label : 'Removed',
          command : this.removed
        }
      ]

      this.coreOrElective = [
        {
          label : 'Core',
          command : this.core
        },
        {
          label : 'Elective',
          command : this.elective
        }
      ]

  }
  ngOnInit(): void {
    this.firstLoad = true;
    this.assignmentGroupInteractionService.updatePanelList$.subscribe(
      (syncData) => {
        if(syncData) {
        setTimeout(() => {        
          this.getCurriculumManagementData();
        }, 1000);
      }
      }
    );
    this.curriculumScopeId = this.selectedScope.data.eQMSScopeId;
  }

  ngOnChanges() {
    this.curriculumScopeId = this.selectedScope.data.eQMSScopeId;
    this.firstLoad = true;
    this.setPanelList();
  }

  setPanelList(){
    this.curriculumManagementData.lists = this.trainingItems;    
    this.curriculumManagementData.sort = this.getSortingFields();
    this.curriculumManagementData.filters =  this.getFilters();
    this.curriculumManagementData = { ...this.curriculumManagementData }
  }

  checkboxSelection(bool : any){
    this.firstLoad = false;
    this.getCurriculumManagementData();
  }

  //Update Status of training items
  active = () =>{
    var status = CurriculumConstants.Curriculum_StatusActive;
    this.validateSelectedTrainingItemsForStatus(CurriculumConstants.Curriculum_StatusNameActive);
    this.prepareDataForUpdateStatus(status);
  }

  removed = () =>{
    var status = CurriculumConstants.Curriculum_StatusRemoved;
    this.validateSelectedTrainingItemsForStatus(CurriculumConstants.Curriculum_StatusNameRemoved);
    this.prepareDataForUpdateStatus(status);
  }

  validateSelectedTrainingItemsForStatus(status : string){
    var linkedItems : LinkedTrainingItems[] = [];
    this.selectedTrainingItems.map(item =>{
      if(item.status == status){
        var linkedItem : LinkedTrainingItems = {
          number : item.number,
          version : item.version,
          title : item.title
        }
        linkedItems.push(linkedItem);
      }
    })
    if(linkedItems.length>0){
      this.displayWarningMessageForStatus(linkedItems);
    }
    this.selectedTrainingItems = this.selectedTrainingItems.filter(item =>
       !linkedItems.find(a=>a.number == item.number))
  }

  prepareDataForUpdateStatus(status : number){
    var trainingItemNumbers : string[] = []
    Object.values(this.selectedTrainingItems).map(training => {
      trainingItemNumbers.push(training.number);
    });
    var statusDto : TrainingItemUpdateDto ={
      status : status,
      eqmsScope : this.selectedScope.data.eQMSScopeId,
      trainingItemNumbers : trainingItemNumbers
    }
    this.updateStatus(statusDto);
  }

  updateStatus(statusDto : TrainingItemUpdateDto){
    if(statusDto.trainingItemNumbers.length > 0){
      this.curriculumService.updateStatusOfTrainingItems(statusDto)
      .pipe(
        catchError((err) => {
          this.addFailureMessage();
          return throwError(() => err);
        }),takeUntil(this.destroy$)
      ).subscribe( doc =>{
        var statusName = "";
        switch(statusDto.status){
          case CurriculumConstants.Curriculum_StatusActive:
            statusName = CurriculumConstants.Curriculum_StatusNameActive;
            break;
            case CurriculumConstants.Curriculum_StatusRemoved:
              statusName = CurriculumConstants.Curriculum_StatusNameRemoved;
              break;
        }
        const validationMessage = CurriculumConstants.TrainingItems_StatusUpdatedMessage.replace(
          'StatusName',
          `\n${statusName}`
        );
        this.messageService.add({
          severity:CurriculumConstants.Severity_Success,
          summary: `${validationMessage}`
        })
        this.resetPanelList();
      })
    }
  }

  //Update Core or Elective
  core = () =>{
    var coreOrElective = CurriculumConstants.Curriculum_Core;
    this.validateRemovedStatusTrainingItems();
    this.validateSelectedTrainingItemsForCoreOrElective(CurriculumConstants.Curriculum_CoreName);
    this.prepareDataForUpdateCoreOrElective(coreOrElective);
  }
  elective = () =>{
    var coreOrElective = CurriculumConstants.Curriculum_Elective;
    this.validateRemovedStatusTrainingItems();
    this.validateSelectedTrainingItemsForCoreOrElective(CurriculumConstants.Curriculum_ElectiveName);
    this.prepareDataForUpdateCoreOrElective(coreOrElective);
  }

  validateRemovedStatusTrainingItems(){
    var linkedItems : LinkedTrainingItems[] = [];
    this.selectedTrainingItems.map((item=>{
      if(item.status == CurriculumConstants.Curriculum_StatusNameRemoved){
        var linkedItem : LinkedTrainingItems = {
          number : item.number,
          version : item.version,
          title : item.title
        }
        linkedItems.push(linkedItem);
      }
    }))
    if(linkedItems.length > 0){
      this.displayWarningMessageForRemovedStatus(linkedItems);
    }
    this.selectedTrainingItems = this.selectedTrainingItems.filter(item =>
       !linkedItems.find(a=>a.number == item.number))
  }

  validateSelectedTrainingItemsForCoreOrElective(coreOrElective : string){
    var linkedItems : LinkedTrainingItems[] = [];
    this.selectedTrainingItems.map((item=>{
      if(item.coreOrElective == coreOrElective){
        var linkedItem : LinkedTrainingItems = {
          number : item.number,
          version : item.version,
          title : item.title
        }
        linkedItems.push(linkedItem);
      }
    }))
    if(linkedItems.length > 0){
      this.displayWarningMessageForCoreOrElective(linkedItems);
    }
    this.selectedTrainingItems = this.selectedTrainingItems.filter(item =>
       !linkedItems.find(a=>a.number == item.number))
  }

  prepareDataForUpdateCoreOrElective(coreOrElective : number){
    var trainingItemNumbers : string[] = []
    this.selectedTrainingItems.map(training => 
      trainingItemNumbers.push(training.number));
    var coreOrElectiveDto : TrainingItemUpdateDto ={
      coreOrElective : coreOrElective,
      eqmsScope : this.selectedScope.data.eQMSScopeId,
      trainingItemNumbers : trainingItemNumbers
    }
    this.updateCoreOrElective(coreOrElectiveDto);
  }
  updateCoreOrElective(coreOrElectiveDto : TrainingItemUpdateDto){
    if(coreOrElectiveDto.trainingItemNumbers.length > 0){
      this.curriculumService.updateCoreOrElectiveOfTrainingItems(coreOrElectiveDto)
      .pipe(
        catchError((err) => {
          this.addFailureMessage();
          return throwError(() => err);
        }),takeUntil(this.destroy$)
      ).subscribe( doc =>{
        var coreOrElectiveName = "";
        switch(coreOrElectiveDto.coreOrElective){
          case CurriculumConstants.Curriculum_Core:
            coreOrElectiveName = CurriculumConstants.Curriculum_CoreName;
            break;
          case CurriculumConstants.Curriculum_Elective:
            coreOrElectiveName = CurriculumConstants.Curriculum_ElectiveName;
            break; 
        }
        const validationMessage = CurriculumConstants.TrainingItems_CoreOrElectiveUpdatedMessage.replace(
          'CoreOrElective',
          `\n${coreOrElectiveName}`
        );
        this.messageService.add({
          severity:CurriculumConstants.Severity_Success,
          summary: `${validationMessage}`
        })
        this.resetPanelList();
      })
    }
  }

  addFailureMessage(){
    this.messageService.add({
      severity: CurriculumConstants.Severity_Err,
        summary: `${CurriculumConstants.Curriculum_FailureToUpdate}`
    })
  }
  resetPanelList(){
    this.ifItemsAreSelected = false;
    this.clearSelection();
    this.assignmentGroupInteractionService.updatePanelListOnCreateOrEdit();
  }
  getSelectedItems(trainingItems : any){
    if(trainingItems.length > 0){
      this.ifItemsAreSelected = true;
    }
    else{
      this.ifItemsAreSelected = false;
    }
    this.selectedTrainingItems = []
    this.selectedTrainingItems = trainingItems;
  }

  getCurriculumManagementData(){
    this.isScopeSelected = true;
    this.firstLoad ? this.spinnerOn = true : this.showPanelLoader = true;
    this.documentNumbers = [];
    this.courseNumbers = [];
    var trainingItemDto : TrainingItemDto ={
      eqmsScope : this.selectedScope.data.eQMSScopeId,
      showAll : this.showAll
    }    
    this.curriculumService.getTrainingItems(trainingItemDto)
    .pipe(
      catchError((err) => {
        this.trainingItems = []
        this.setPanelList();
        this.noData = this.commonService.IsListEmpty(this.curriculumManagementData.lists);
        this.firstLoad ? this.spinnerOn = false : this.showPanelLoader = false;
        this.buttonsShouldBeDisplayed = false;
        return throwError(() => err);
      }),takeUntil(this.destroy$)
    )
    .subscribe( (result:{records:any, unavailableItems: string[]}): void =>{
        this.trainingItems = result.records;
        this.unavailableItems = result.unavailableItems;
        if(this.unavailableItems.length > 0){
          let desc = this.unavailableItems.join(", ");
          this.messageService.add({
            severity:  CurriculumConstants.Severity_Err,
            summary: CurriculumConstants.Curriculum_ErrorWhileFetchingTrainingItems,
            detail: desc,
            sticky: true
          });
        }

        this.setPanelList();
        this.noData = this.commonService.IsListEmpty(this.curriculumManagementData.lists);
        this.firstLoad ? this.spinnerOn = false : this.showPanelLoader = false;
        this.buttonsShouldBeDisplayed = true;
       }
      )
  }

  openDocument(documentNumber: string, version : string){
    var url = location.origin.concat("/eqms.documentDetails/", documentNumber, ":", version);
    window.open(url, "_blank");
  }

  openCourse(courseNumber : string){
    var url = location.origin.concat("/training/eqms.courses/", courseNumber);
    window.open(url, "_blank");
  }

  getSortingFields= (): SortMenu[]=>{
    let sortMenu: SortMenu[] = [];
    sortMenu.push({
        sortFieldDisplayName: 'Type',
        sortFieldName: 'typeName',
      },
      {
        sortFieldDisplayName: 'Status',
        sortFieldName: 'status',
      },
      {
        sortFieldDisplayName: 'Core/Elective',
        sortFieldName: 'coreOrElective',
      });
      return sortMenu;
    }

  getFilters =():FilterMenu[] => {
    let filterMenu : FilterMenu[] = [];
    filterMenu.push({
      filterDisplayName: 'Type',
      filterFieldName: 'typeName',
    },
    {
      filterDisplayName: 'Status',
      filterFieldName: 'status',
    },
    {
      filterDisplayName: 'Core/Elective',
      filterFieldName: 'coreOrElective',
    });
    return filterMenu;
  }

  
  displayWarningMessageForStatus(linkedItems : LinkedTrainingItems[]){
    const trainingItemCode = linkedItems.map((item) => `${item.number}  ${item.title}`).join(",");
    const validationMessage = CurriculumConstants.Curriculum_WarningMessageForSameStatusTrainingItem.replace(
      'TrainingItemCodes',
      `\n${trainingItemCode}`
    );
    this.messageService.add({
      severity: CurriculumConstants.Severity_Warning,
      summary: `${validationMessage}`,
      life: 10000 
    });
    this.clearSelection();
  }

  
  displayWarningMessageForRemovedStatus(linkedItems : LinkedTrainingItems[]){
    const trainingItemCode = linkedItems.map((item) => `${item.number} ${item.title}`).join(",");
    const validationMessage = CurriculumConstants.Curriculum_WarningMessageForRemovedStatusTrainingItem.replace(
      'TrainingItemCodes',
      `\n${trainingItemCode}`
    );
    this.messageService.add({
      severity: CurriculumConstants.Severity_Warning,
      summary: `${validationMessage}`,
      life: 10000 
    });
    this.clearSelection();
  }

  displayWarningMessageForCoreOrElective(linkedItems : LinkedTrainingItems[]){
    const trainingItemCode = linkedItems.map((item) => `${item.number} ${item.title}`).join(",");
    const validationMessage = CurriculumConstants.Curriculum_WarningMessageForSameCoreOrElectiveTrainingItem.replace(
      'TrainingItemCodes',
      `\n${trainingItemCode}`
    );
    this.messageService.add({
      severity: CurriculumConstants.Severity_Warning,
      summary: `${validationMessage}`,
      life: 10000 
    });
    this.clearSelection();
  }

  clearSelection(){
    this.curriculumManagementData.clearSelection = true;
    this.curriculumManagementData = { ...this.curriculumManagementData };
  }

  ngOnDestroy = () => {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
   }
  
  openUnAssignTrainingItemGroupSlider = () =>{
    this.isUnAssignTrainingItemGroupSliderOpen = true;
    this.getTrainingItemGroups();
  }

  closeUnAssignTrainingItemGroupSlider = (isSliderActive : boolean) =>{
    this.isUnAssignTrainingItemGroupSliderOpen = isSliderActive;
  }

  refreshCurriculumOnUnAssignTrainingItemGroups = (isRefresh : boolean) =>{
    if(isRefresh){
      this.resetPanelList();
    }
  }

  selectedTrainingItemGroupsList = (selectedGroups : string[]) =>{
    this.selectedTrainingItemGroups = selectedGroups;
  }

  unAssignTrainingItemGroupsFromCurriculum = () => {
    if (this.selectedTrainingItemGroups.length === 0) return;

    this.curriculumService
      .unAssignTrainingItemGroupsFromCurriculum(this.curriculumScopeId, this.selectedTrainingItemGroups)
      .subscribe({
        next: () => {
          this.messageService.add({
            severity: SharedConstants.Severity_Success,
            summary: CurriculumConstants.Curriculum_UnAssign_Training_Item_Group_Success_Message,
            sticky: false
          });
          this.closeUnAssignTrainingItemGroupSlider(false);
          this.refreshCurriculumOnUnAssignTrainingItemGroups(true);
        },
        error: () => {
          this.messageService.add({
            severity: SharedConstants.Severity_Error,
            summary: CurriculumConstants.Curriculum_UnAssign_Training_Item_Group_Error_Message,
            sticky: false
          });
          this.refreshCurriculumOnUnAssignTrainingItemGroups(false);
          this.closeUnAssignTrainingItemGroupSlider(false);
        }
      });
  }

    getTrainingItemGroups = () => {
      if (!this.curriculumScopeId || this.curriculumScopeId === '') return;
      this.curriculumService.getTrainingItemGroupsForCurriculum(this.curriculumScopeId)
        .subscribe({
          next: (response) => this.trainingItemGroups = response,
          error: () => {
            this.messageService.add({
              severity: SharedConstants.Severity_Error,
              summary: CurriculumConstants.Curriculum_Fetch_Training_Item_Group_Error_Message,
              sticky: false
            });
          }
        });
    }

}
